// src/App.tsx
import React, { useState, useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext, User } from './context/AuthContext';
import AuthPage from './pages/AuthPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import './App.css';

function App() {
    // Теперь мы храним только токен и самого пользователя
    const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
    const [user, setUser] = useState<User | null>(() => {
        try {
            const storedUser = localStorage.getItem('user');
            return storedUser ? JSON.parse(storedUser) : null;
        } catch (error) {
            return null;
        }
    });

    // Функция login теперь просто сохраняет готовые данные
    const login = (newToken: string, username: string, role: 'user' | 'admin') => {
        const loggedInUser: User = { username, role, is_blocked: false }; // isBlocked больше не проверяем на фронте

        localStorage.setItem('token', newToken);
        localStorage.setItem('user', JSON.stringify(loggedInUser));

        setToken(newToken);
        setUser(loggedInUser);
    };

    // Logout остаётся прежним
    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setToken(null);
        setUser(null);
    };

    // Заглушки для функций, которые мы реализуем позже
    const registerUser = () => ({ success: false, message: 'Not implemented' });
    const updateUserStatus = () => {};
    const deleteUser = () => {};
    const getUserBasicLists = () => [];
    const allUsers: User[] = []; // Больше не храним всех пользователей на фронте

    // Передаем в контекст только то, что нужно
    const authContextValue = useMemo(() => ({
        token,
        user,
        login,
        logout,
        // Передаем заглушки
        allUsers,
        registerUser,
        updateUserStatus,
        deleteUser,
        getUserBasicLists,
    }), [token, user]);

    return (
        <AuthContext.Provider value={authContextValue}>
            <Router>
                <Routes>
                    <Route path="/login" element={<AuthPage />} />
                    <Route
                        path="/dashboard"
                        element={token ? <DashboardPage /> : <Navigate to="/login" replace />}
                    />
                    <Route
                        path="/admin"
                        element={token && user?.role === 'admin' ? <AdminPage /> : <Navigate to="/login" replace />}
                    />
                    <Route
                        path="*"
                        element={token ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />}
                    />
                </Routes>
            </Router>
        </AuthContext.Provider>
    );
}

export default App;